export const documents = (state) => state.documents
export const selectAllField = (state) => state.selectAllField
export const selectedDocuments = (state) => state.selectedDocuments
export const totalDocuments = (state) => state.totalDocuments
export const getDocument = (state) => (id) => {
  let invId = parseInt(id)
  return state.documents.find((document) => document.id === invId)
}
